import { AppSettings } from 'app/app.settings';
import { CommonRequestService } from './common-request.service';
import { UserService } from './user.service';
import * as i0 from "@angular/core";
import * as i1 from "./common-request.service";
import * as i2 from "./user.service";
var GtoService = /** @class */ (function () {
    function GtoService(requestService, userService) {
        this.requestService = requestService;
        this.userService = userService;
        this.test = {
            geom: '0101000020110F000000000000009898400000000000C05D40',
            layer: 'default',
            mpt_guid: '{398F6F59-C422-4AE7-8A39-18F3F3FFCDE3}',
            mpt_reach: 1,
            mpt_redaction: 'R-ReDraw is also Redacted',
            mpt_resolved: true,
            mpt_session_id: '2d7bbc01-526c-49af-b20e-eac3cee3ac38',
            mpt_split_insert: 'I',
            mpt_state_cd: 'AZ'
        };
    }
    GtoService.prototype.buildGto = function (table, operation, keyCol, properties, whereClause, keyColType, keyColValues) {
        var gto = {
            table: table,
            operation: operation,
            keycol: keyCol,
            properties: properties
        };
        if (whereClause) {
            gto.where = whereClause;
        }
        if (keyColType) {
            gto.keytyp = keyColType;
        }
        if (keyColValues) {
            gto.keyvals = keyColValues;
        }
        return gto;
    };
    GtoService.prototype.processGto = function (gto, globalIdCol) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'common/processGto';
            var body = {
                gto: JSON.stringify({
                    dbprocs: gto
                }),
                userId: _this.userService.getUserInfo().userId,
                userSubscriptionId: _this.userService.getUserInfo().userSubId,
                source: 'C' // cloud
            };
            if (globalIdCol) {
                body.columnReturn = globalIdCol;
            }
            _this.requestService.requestPost(url, body, function (rsp) {
                console.log(rsp);
                var globalIds = [];
                if (globalIdCol && rsp.data && rsp.data.content) {
                    var obj = JSON.parse(rsp.data.content);
                    if (obj[globalIdCol]) {
                        globalIds = obj[globalIdCol];
                    }
                }
                resolve({
                    sessionId: rsp.misc.session_id,
                    globalIds: globalIds
                });
            }, function (err) { return reject(err); }, true);
        });
    };
    GtoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GtoService_Factory() { return new GtoService(i0.ɵɵinject(i1.CommonRequestService), i0.ɵɵinject(i2.UserService)); }, token: GtoService, providedIn: "root" });
    return GtoService;
}());
export { GtoService };
